import { createContext, useContext } from 'react';

interface SystemMessages {
  Name: string;
  Value: string;
  DataType: string;

}

interface SystemConfig {
  Id: string;
  Value: string;
}

interface SystemMessagesContextType {

  systemMessages: SystemMessages[];

  setSystemMessages: React.Dispatch<React.SetStateAction<SystemMessages[]>>;

  systemConfig: SystemConfig[];

  setSystemConfig: React.Dispatch<React.SetStateAction<SystemConfig[]>>;

}

export const SystemMessagesContext = createContext<SystemMessagesContextType | undefined>(undefined);

export const useSystemMessages = () => {
  const context = useContext(SystemMessagesContext);
  if (context === undefined) {
    throw new Error('useSystemMessages must be used within a SystemMessagesProvider');
  }
  return context;
};